import { atom } from 'recoil'

export const modalThirdPartyState = atom({
  key: 'rowEditModalThirdPartyState',
  default: {
    show: false
  }
})

export const modalConfirmLeaveState = atom({
  key: 'rowEditModalConfirmLeaveState',
  default: {
    afterExit: false
  }
})

export const modalSaveNewAndRenameState = atom({
  key: 'rowEditModalSaveNewState',
  default: {
    show: false,
    mode: '',
    name: undefined
  }
})
